import React from 'react';
import { toast as toastify } from 'react-toastify';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import Button from 'chameleon/ui-stack/ui/base/button';
import { Link } from 'react-router';

const defaultConfig = {
  actionLink: null,
  actionText: '',
  hasCheckmark: false,
};

const CloseButton = () => {
  return (
    <div className="self-center">
      <Icon id="close" width="15" height="15" />
    </div>
  );
};

const ToastBody = ({ actionLink, actionText, hasCheckmark, children }) => {
  return (
    <div className="flex flex-row items-center">
      {hasCheckmark && (
        <Icon
          className="fill-current text-white mr-6"
          id="circle_checkmark"
          width="20"
          height="20"
        />
      )}
      <div role="alert">{children}</div>
      {actionLink && (
        <div className="ml-4">
          <Button
            accessibility={{ 'aria-label': actionText }}
            isNaked
            isLink
            className="p-0 h-0"
          >
            <Link className="text-blue-500 font-bold" to={actionLink}>
              {actionText}
            </Link>
          </Button>
        </div>
      )}
    </div>
  );
};

const toast = (content, config = {}) => {
  const { actionLink, hasCheckmark, autoClose, actionText } = {
    ...defaultConfig,
    ...config,
  };
  const toastConfig = {
    autoClose,
    // if the toast has action link then don't show the close button
    closeButton: actionLink ? <CloseButton /> : false,
  };

  const Comps = (
    <ToastBody
      actionLink={actionLink}
      actionText={actionText}
      hasCheckmark={hasCheckmark}
    >
      {content}
    </ToastBody>
  );
  toastify(Comps, toastConfig);
};

// TODO ui to be finalized by CB
const errorToast = (content) => {
  const Comps = <ToastBody>{content}</ToastBody>;
  toastify.error(Comps);
};

toast.error = errorToast;

export default toast;
